import { Icon } from '@iconify/react';
import PropTypes from 'prop-types';
import { memo } from 'react';
import "./ToasterItem.scss";

const ToastItem = ({ toastsArr, onRemove }) => {
    const getIcon = (type) => {
        switch (type) {
            case 'success':
                return 'lucide:check-circle';
            case 'error':
                return 'lucide:x-circle';
            case 'warning':
                return 'lucide:alert-triangle';
            case 'info':
            default:
                return 'lucide:info';
        }
    };

    return (
        <div className="toaster-container">
            {toastsArr.map((toast, index) => (
                <div key={toast.id} className={`toast-item ${toast.type}`}>
                    <div className="toast-icon">
                        <Icon icon={getIcon(toast.type)} width={20} />
                    </div>

                    <div className="toast-content">
                        <div className="toast-title">{toast.title}</div>
                        {toast.description && (
                            <div className="toast-description">{toast.description}</div>
                        )}
                        {toast.action && (
                            <button className="toast-action" onClick={toast.action.onClick}>
                                {toast.action.label}
                            </button>
                        )}
                    </div>

                    <button className="toast-close" onClick={() => onRemove(toast.id)}>
                        <Icon icon="material-symbols:close-rounded" width={16} />
                    </button>
                </div>
            ))}
        </div>
    );
};

ToastItem.prototype = {
    toastsArr: PropTypes.arrayOf(PropTypes.object).isRequired,
    onRemove: PropTypes.func.isRequired,
};

export default memo(ToastItem);